module.exports = __webpack_public_path__ + "img/C4.71520496.png";